/**
 * Module definition and dependencies
 */
angular.module("Crm.ContacterContacts.Controller", ["messageService.Service", "trumbowyg-ng", "ngMessages", "toaster", "ngFileUpload"])
/**
 * Controller
 */
.controller("ContacterContactsCtrl", ["$rootScope", "Message", "toaster", "ListeContacts", "listDocumentsSelectionner", "Upload", "Config", // "Token",
"$scope", function ($rootScope, Message, toaster, ListeContacts, listDocumentsSelectionner, Upload, Config, // Token,
$scope) {
  var self = this; // var token;

  self.$onInit = function () {
    // token = Token.read();
    this.svgPathTrumbowyg = $rootScope.env === "immodesk" ? "/node_modules/crm_modules/dist/images/icons.svg" : "icons/icons.svg";
    self.disabledCopievendeur = true;

    if (listDocumentsSelectionner) {
      self.listDocumentsSelectionner = angular.copy(listDocumentsSelectionner);
      self.totalSizeFiles();
    } else {
      self.totalSizeDocumentsSelectionner = 0;
      self.totalSizeListUploadDocuments = 0;
    }

    if (!self.listUploadDocumentsBase) {
      self.listUploadDocuments = [];
    }

    self.maxSizeFiles = 16000000;
    $rootScope.showModalLg = false;
    self.viewSuccessSend = 0;
    self.viewUploadFile = 0;
    self.viewSuccessUpload = 0;
    self.listContacts = ListeContacts.getListeContacts();

    if (!self.listContacts) {
      self.listContacts = [];
    } else {
      if (Array.isArray(self.listContacts) && self.listContacts.length === 1) {
        self.contact = self.listContacts[0];
      }
    }
  };

  self.totalSizeFiles = function () {
    self.totalSizeDocumentsSelectionner = 0;
    self.totalSizeListUploadDocuments = 0;

    if (self.listDocumentsSelectionner) {
      angular.forEach(self.listDocumentsSelectionner, function (item, key) {
        if (item.size) {
          self.totalSizeDocumentsSelectionner += parseFloat(item.size);
        }
      });
    }

    if (self.listUploadDocuments) {
      angular.forEach(self.listUploadDocuments, function (item, key) {
        if (item.size) {
          self.totalSizeListUploadDocuments += parseFloat(item.size);
        }
      });
    }
  };

  self.supprimerContact = function (index) {
    self.listContacts.splice(index, 1);
  };

  self.supprimerDocuments = function (tab, index) {
    tab.splice(index, 1);
    self.totalSizeFiles();
  };

  self.beforeSendMessage = function () {
    $rootScope.showModalLg = false; // if (self.listUploadDocuments.length > 0 && token) {

    if (self.listUploadDocuments.length > 0) {
      self.viewUploadFile = 1;
      self.listUploadDocuments.progress = 0;
      return self.uploadMultiPart(self.listUploadDocuments);
    } else {
      return self.sendMessage();
    }
  };

  self.sendMessage = function () {
    self.message = {
      contact_id: self.getListeContactsId(),
      sujet: self.email.sujet,
      message: self.email.message
    };

    if (self.copieVendeur) {
      self.message.copie_vendeur = 1;
    }

    if (self.listDocumentsSelectionner) {
      self.message.documents_id = self.listDocumentsSelectionner.map(item => item.id).join(",");
    }

    if (self.listUploadDocumentsBase64 && self.listUploadDocumentsBase64.length > 0) {
      self.message.documents_base64 = self.listUploadDocumentsBase64.map(item => item.base64);
    }

    if (self.arrayFilesUrls) {
      self.message.documents_path = self.arrayFilesUrls.join(",");
    } //Param pour ADV


    if ($rootScope.env && $rootScope.env === "immodesk") {
      self.message.adv = true;
    }

    return Message.save(self.message).$promise.then(function (response) {
      const errors = response.errors && response.errors.length > 0;

      if (errors) {
        self.messageError = "Les destinataires suivants n'ont pas reçu votre message : " + response.errors.join(", ");
        toaster.pop({
          type: "error",
          title: "",
          body: self.messageError
        });
      }

      if (response.success) {
        self.messageSuccess = errors ? "Votre message a bien été envoyé : " + response.success.join(", ") : "Votre message a bien été envoyé";
        toaster.pop({
          type: "success",
          title: "",
          body: self.messageSuccess
        });
      }

      self.viewUploadFile = 0;
      self.viewSuccessSend = 1;
    }).catch(function (error) {
      $rootScope.showModalLg = true;
      self.viewUploadFile = 0;
      self.viewSuccessSend = 0;
      toaster.pop({
        type: "error",
        title: "",
        body: error.message.toString(),
        bodyOutputType: "trustedHtml"
      });
    });
  };

  self.getListeContactsId = function () {
    if (self.listContacts !== undefined) {
      if (Array.isArray(self.listContacts)) {
        return self.listContacts.map(item => item.id).join(",").toString();
      } else {
        return self.listContacts = self.listContacts.id;
      }
    }
  };

  self.toggleContent = function (showContent) {
    if (self.showContent === showContent) {
      self.showContent = 0;
      $rootScope.showModalLg = false;
    } else {
      self.showContent = showContent;
      $rootScope.showModalLg = true;
    }
  };

  self.uploadMultiPart = function (files) {
    angular.forEach(files, function (file, key) {
      let uploadFileToApi = Upload.upload({
        url: Config.API_BASE_URL + "/documents/uploads",
        data: {
          key: key,
          file: file
        }
      });
      uploadFileToApi.then(function (response) {
        if (!Array.isArray(self.arrayFilesUrls)) {
          self.arrayFilesUrls = [];
        }

        self.arrayFilesUrls.push(response.data);

        if (files.length === self.arrayFilesUrls.length) {
          self.viewSuccessUpload = 1;
          self.sendMessage();
        }
      }, function (response) {
        if (response.status > 0) {
          $scope.errorMsg = response.status + ": " + response.data;
        } else {
          self.errorUploadFiles = response;
        }
      }, function (evt) {
        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
      });
    });
  }; // $scope.$watch(() => self.listContacts,(val, old) => {
  //   self.checkCopieVendeur();
  // },true);

}]).controller("ContacterContactsBtnCtrl", ["$state", "ListeContacts", "$uibModal", "$rootScope", function ($state, ListeContacts, $uibModal, $rootScope) {
  var self = this;

  self.$onInit = function () {
    if (!self.label) {
      self.label = "Écrire";
    }

    if (!self.type) {
      self.type = "button";
    }
  };

  self.listeContactsSelectionner = function (action) {
    if (self.contactsSelectionner) {
      ListeContacts.setListeContacts(self.contactsSelectionner);
    }

    if (action === "ecrire") {
      self.openModalContact();
    }

    if (action === "modifier_attribution") {
      self.openModalAttribution();
    }

    if (action === "modifier_avancement_commercial") {
      self.openModalAvancementCommercial();
    }

    if (action === "supprimer-contact") {
      self.openModalDeleteContacts();
    }
  };
  /*
   * Modal openModalContact
   */


  self.openModalContact = function () {
    var modalInstance = $uibModal.open({
      windowTemplateUrl: "src/contacter-contacts/modal-window-lg.html",
      templateUrl: "src/contacter-contacts/modal-contacter-contacts.html",
      controller: "ContacterContactsCtrl",
      controllerAs: "$ctrl",
      resolve: {
        listDocumentsSelectionner: function () {
          return self.listDocumentsSelectionner;
        }
      }
    });
    modalInstance.result.then(function (selectedItem) {
      self.selected = selectedItem;
    });
  };
  /*
   * Modal openModalAttribution
   */


  self.openModalAttribution = function () {
    var modalInstance = $uibModal.open({
      templateUrl: "admin/attribution/modal-attribution-contacts.html",
      controller: "AttributionCtrl",
      controllerAs: "$ctrl"
    });
    modalInstance.result.then(function (selectedItem) {
      self.selected = selectedItem;
    });
  };
  /*
   * Modal openModalAvancementCommercial
   */


  self.openModalAvancementCommercial = function () {
    var modalInstance = $uibModal.open({
      templateUrl: "avancement-commercial/modal-avancement-commercial.html",
      controller: "ModalAvancementCommercialCtrl",
      controllerAs: "$ctrl"
    });
    modalInstance.result.then(function (selectedItem) {
      self.selected = selectedItem;
    });
  };
  /*
   * Modal openModalDeleteContacts
   */


  self.openModalDeleteContacts = function () {
    let modalInstance = $uibModal.open({
      templateUrl: "admin/delete-contact/modal-confirmation-delete-contact.html",
      controller: "DeleteContactCtrl",
      controllerAs: "$ctrl",
      resolve: {
        contact: function () {
          return self.contactsSelectionner.map(item => item.id).join(",");
        }
      }
    });
    modalInstance.result.then(function (response) {
      if (response.success) {
        self.contactsSelectionner = [];
        $rootScope.$broadcast("updateContacts");
      }
    });
  };
}]);
/**
 * Module definition and dependencies
 */

angular.module("Crm.ContacterContacts", ["Crm.ContacterContacts.Controller", "Crm.contacter-contacts.templates"]).component("actionsGroupeesBtn", {
  controller: "ContacterContactsBtnCtrl",
  templateUrl: "src/contacter-contacts/contacter-contacts-actions-groupees-btn.html",
  bindings: {
    contactsSelectionner: "<",
    btnIndex: "<",
    typeAffichage: "<"
  }
}).component("ecrireBtn", {
  controller: "ContacterContactsBtnCtrl",
  templateUrl: "src/contacter-contacts/contacter-contacts-ecrire-btn.html",
  bindings: {
    contactsSelectionner: "<",
    listDocumentsSelectionner: "<",
    btnIndex: "<",
    disabled: "<",
    addClass: "<",
    label: "<",
    type: "<"
  }
}).component("contacterContacts", {
  controller: "ContacterContactsCtrl",
  templateUrl: "src/contacter-contacts/contacter-contacts.html"
});
angular.module('Crm.contacter-contacts.templates', []).run(['$templateCache', function($templateCache) {$templateCache.put('src/contacter-contacts/contacter-contacts-actions-groupees-btn.html','<div class="btn-group" is-open="status.isopen" uib-dropdown="" ng-if="$ctrl.typeAffichage === \'groupe\' || $ctrl.typeAffichage === undefined"> <button class="btn btn-tertiary" id="actions-groupees" type="button" uib-dropdown-toggle="" ng-disabled="!$ctrl.contactsSelectionner.length > 0"> Actions group\xE9es<i class="fa fa-caret-down icon-next"></i></button><ul aria-labelledby="actions-groupees" class="dropdown-menu" role="menu" uib-dropdown-menu=""><li role="menuitem" ng-if="$root.configsCommercialisateurs.messagerie_desactiver === false"> <a ng-click="$ctrl.listeContactsSelectionner(\'ecrire\')">\xC9crire</a></li><li role="menuitem" admin-only> <a ng-click="$ctrl.listeContactsSelectionner(\'modifier_attribution\')">Modifier l\'attribution</a></li><li role="menuitem"> <a ng-click="$ctrl.listeContactsSelectionner(\'modifier_avancement_commercial\')">Modifier l\'avancement commercial</a></li><li role="menuitem" admin-only> <a ng-click="$ctrl.listeContactsSelectionner(\'supprimer-contact\')"><span ng-if="$ctrl.contactsSelectionner.length === 1">Supprimer le contact</span> <span ng-if="$ctrl.contactsSelectionner.length > 1">Supprimer les contacts</span></a></li></ul></div><div class="d-flex d-flex-1" ng-if="$ctrl.typeAffichage === \'liste\'"><div class="b-left"> <a class="btn btn-xs btn-primary" ng-click="$ctrl.listeContactsSelectionner(\'ecrire\')">\xC9crire</a> <a class="btn btn-xs btn-primary" ng-click="$ctrl.listeContactsSelectionner(\'modifier_attribution\')">Modifier l\'attribution</a> <a class="btn btn-xs btn-primary" ng-click="$ctrl.listeContactsSelectionner(\'modifier_avancement_commercial\')">Modifier l\'avancement commercial</a></div><div class="d-flex-right"> <a class="btn btn-xs btn-secondary" ng-click="$ctrl.listeContactsSelectionner(\'supprimer-contact\')"><span ng-if="$ctrl.contactsSelectionner.length === 1">Supprimer le contact</span> <span ng-if="$ctrl.contactsSelectionner.length > 1">Supprimer les contacts</span></a></div></div>');
$templateCache.put('src/contacter-contacts/contacter-contacts-ecrire-btn.html','<button ng-class="{\'btn btn-secondary\' : $ctrl.addClass === \'undefined\', \'{{ $ctrl.addClass }}\' : $ctrl.addClass.length >= 0}" ng-disabled="!$ctrl.disabled" ng-click="$ctrl.listeContactsSelectionner(\'ecrire\'); $event.stopPropagation();" ng-if="$ctrl.type === \'button\'">{{ $ctrl.label }}</button> <a ng-class="{\'btn btn-secondary\' : $ctrl.addClass === \'undefined\', \'{{ $ctrl.addClass }}\' : $ctrl.addClass.length >= 0}" ng-disabled="!$ctrl.disabled" ng-click="$ctrl.listeContactsSelectionner(\'ecrire\'); $event.stopPropagation();" ng-if="$ctrl.type === \'a\'">{{ $ctrl.label }}</a>');
$templateCache.put('src/contacter-contacts/contacter-contacts.html','<a onclick="window.history.back()" class="btn btn-primary mb-1">Retour</a><div class="panel"><div class="panel-heading"><h3 class="panel-title h4">Envoyer un messages \xE0 ces contacts</h3></div><div class="panel-body"><div class="row"><div class="col-xs-12"> <span class="well well-sm" ng-repeat="item in $ctrl.contactsSelectionner" ng-click="$ctrl.supprimerContact($index)">{{ item.prenom }} <span class="uppercase">{{ item.nom }} <i class="material-icons md-18">close</i></span></span></div></div><div class="row"><div class="col-xs-12"> <input type="text" placeholder="Sujet" class="form-control" ng-model="$ctrl.email.sujet"><div trumbowyg-ng placeholder="Votre message" ng-model="$ctrl.email.message" editor-config="{\r\n                  lang: \'fr\',\r\n                  btns: [\'formatting\', \'strong\', \'em\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'unorderedList\', \'orderedList\', \'horizontalRule\'],\r\n                  svgPath: \'icons/icons.svg\',\r\n               }"></div> <button type="submit" promise-btn class="btn btn-primary btn-sm pull-right" ng-disabled="$ctrl.contactsSelectionner.length == undefined || $ctrl.email.sujet.length == 0 || $ctrl.email.sujet.length == undefined || $ctrl.email.message.length == 0 || $ctrl.email.message.length == undefined" ng-click="$ctrl.sendMessage()"><span class="btn-text">Envoyer</span></button></div></div></div></div>');
$templateCache.put('src/contacter-contacts/modal-contacter-contacts.html','<div class="modal-header"> <button type="button" class="close" ng-click="$close()"><span>&times;</span></button><h3 class="modal-title" id="modal-title">Contacter {{ $ctrl.contact.prenom }}&nbsp;<span class="uppercase">{{ $ctrl.contact.nom }}</h3></div><div class="modal-body" id="modal-body"><div ng-if="$ctrl.viewSuccessSend === 0 && $ctrl.viewUploadFile === 0"><div class="row"><div class="col-formulaire"><div class="col-formulaire-btn"> <button class="btn" ng-class="{\'btn-primary\': $ctrl.showContent !== 1, \'btn-secondary\': $ctrl.showContent === 1 && $root.showModalLg}" ng-click="$ctrl.toggleContent(1);"> <span>Destinataires ({{ $ctrl.listContacts.length }})</span></button> <button class="btn" ng-class="{\'btn-primary\': $ctrl.showContent !== 2, \'btn-secondary\': $ctrl.showContent === 2 && $root.showModalLg}" ng-click="$ctrl.toggleContent(2);"> <span>Documents programmes / lots</span></button> <button class="btn" ng-class="{\'btn-primary\': $ctrl.showContent !== 3, \'btn-secondary\': $ctrl.showContent === 3 && $root.showModalLg}" ng-click="$ctrl.toggleContent(3);"> <span>Joindre un fichier</span></button></div> <input type="text" placeholder="Sujet *" class="form-control mb-2" ng-model="$ctrl.email.sujet" ng-required="true" required><div trumbowyg-ng placeholder="Votre message *" ng-model="$ctrl.email.message" editor-config="{\r\n              lang: \'fr\',\r\n              btns: [\'formatting\', \'strong\', \'em\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'unorderedList\', \'orderedList\', \'horizontalRule\'],\r\n              svgPath: $ctrl.svgPathTrumbowyg,\r\n            }"></div></div><div class="col-content"><div class="content-contacts" ng-if="$ctrl.showContent === 1"><div class="mb-1"><rechercher-contacts contact="$ctrl.newContact" show-contact-label="false" list-contacts="$ctrl.listContacts" redirect="true"></rechercher-contacts></div><h3>Liste des destinataires</h3><div class="content-results"><list-contacts list-contacts="$ctrl.listContacts"><list-contacts></div></div><div class="content-documents" ng-if="$ctrl.showContent === 2"><uib-tabset active="active"><uib-tab index="0" heading="Documents"><div class="mt-1"><form-documents filtres-documents="$ctrl.filtresDocuments"></form-documents><list-documents filtres-documents="$ctrl.filtresDocuments" documents="$ctrl.listDocumentsSelectionner" total-size="$ctrl.totalSizeDocumentsSelectionner"></list-documents></div></uib-tab><uib-tab index="1" heading="Rechercher par lot"><div class="mt-1"><form-lots filtres="$ctrl.filtresLots"></form-lots><list-lots filtres="$ctrl.filtresLots" documents="$ctrl.listDocumentsSelectionner" total-size="$ctrl.totalSizeDocumentsSelectionner"></list-lots></div></uib-tab></uib-tabset></div><div class="content-documents" ng-if="$ctrl.showContent === 3"><upload-documents-btn documents="$ctrl.listUploadDocuments" title-button="\'Choisir un fichier\'" pattern="\'.jpg,.jpeg,.pdf,.odt,.ods,.docx,.doc,.xls,.xlsx,.png\'" use-base64="false" total-size="$ctrl.totalSizeListUploadDocuments"></upload-documents-btn><div class="spacer spacer--xs"></div><upload-documents-drag-drop documents="$ctrl.listUploadDocuments" title="\'Glisser / D\xE9poser vos fichiers ici\'" use-base64="false" total-size="$ctrl.totalSizeListUploadDocuments" pattern="\'.jpg,.jpeg,.pdf,.odt,.ods,.docx,.doc,.xls,.xlsx,.png\'"></upload-documents-drag-drop></div></div></div><div class="row" ng-if="$ctrl.listDocumentsSelectionner.length > 0 || $ctrl.listUploadDocuments.length > 0"><div class="col-xs-12"><p>Liste des documents s\xE9lectionn\xE9s ( <span class="file-size" ng-class="{\'oversize-file\': ($ctrl.totalSizeDocumentsSelectionner + $ctrl.totalSizeListUploadDocuments) > $ctrl.maxSizeFiles }">{{ ($ctrl.totalSizeDocumentsSelectionner + $ctrl.totalSizeListUploadDocuments) | bytes }} / {{ $ctrl.maxSizeFiles | bytes }}</span> )</p> <span class="well well-sm" ng-repeat="item in $ctrl.listDocumentsSelectionner" ng-click="$ctrl.supprimerDocuments($ctrl.listDocumentsSelectionner, $index)">{{ item.titre }} <span ng-if="!item.titre">{{ item.nom }} <i class="material-icons md-18">close</i></span> <span class="well well-sm" ng-repeat="item in $ctrl.listUploadDocuments" ng-click="$ctrl.supprimerDocuments($ctrl.listUploadDocuments, $index)">{{ item.name }} <i class="material-icons md-18">close</i></span></span></div></div></div><div class="upload-file" ng-if="$ctrl.viewUploadFile === 1 && !$ctrl.errorUploadFiles"><div class="row"><div class="col-xs-12 col-sm-8 col-sm-offset-2" ng-if="$ctrl.viewSuccessUpload === 0"><p class="style-1">Upload des fichiers<p><uib-progressbar animate="true" value="$ctrl.listUploadDocuments.progress"> <span style="color:white; white-space:nowrap;">{{ $ctrl.listUploadDocuments.progress }}%</span></uib-progressbar><ul class="unstyled"><li ng-repeat="f in $ctrl.listUploadDocuments" class="mb-05">{{f.name}} {{f.$errorParam}}<span class="progress" ng-show="f.progress >= 0"><uib-progressbar animate="true" value="f.progress"> <span style="color:white; white-space:nowrap;">{{ f.progress }}%</span></uib-progressbar></span></li><li ng-repeat="f in errFiles" style="font:smaller">{{f.name}} {{f.$error}} {{f.$errorParam}}</li></ul></div><div class="col-xs-12 col-sm-8 col-sm-offset-2" ng-if="$ctrl.viewSuccessUpload === 1"><div class="content_loader"><div class="loader_1">Loading...</div><p class="style-1">Envoi du message</p></div></div></div></div><div class="error-upload" ng-if=\'$ctrl.errorUploadFiles\'> {{ $ctrl.errorUploadFiles }}</div><div class="alert alert-success" ng-if="$ctrl.viewSuccessSend === 1 && $ctrl.messageSuccess"><p>{{ $ctrl.messageSuccess }}</p></div><div class="alert alert-warning" ng-if="$ctrl.viewSuccessSend === 1 && $ctrl.messageError"><p>{{ $ctrl.messageError }}</p></div></div><div class="modal-footer"><div ng-if="$ctrl.viewSuccessSend === 0 && $ctrl.viewUploadFile === 0"><div class="pull-left mt-05" uib-tooltip="Ce contact n\'est affect\xE9 \xE0 aucun vendeur"> <input type="checkbox" id="copie-vendeur" ng-model="$ctrl.copieVendeur"> <label for="copie-vendeur" class="checkbox">Envoyer une copie au vendeur</label></div> <button type="submit" promise-btn class="btn btn-primary" ng-disabled="$ctrl.email.sujet.length == 0 || $ctrl.email.sujet.length == undefined || $ctrl.email.message.length == 0 || $ctrl.email.message.length == undefined || $ctrl.listContacts.length === 0 || ($ctrl.totalSizeDocumentsSelectionner + $ctrl.totalSizeListUploadDocuments) > $ctrl.maxSizeFiles" ng-click="$ctrl.beforeSendMessage();"> <span class="btn-text">Envoyer</span></button></div> <button type="button" ng-if="$ctrl.viewSuccessSend === 1 || $ctrl.errorUploadFiles" class="btn btn-primary" ng-click="$close()">OK</span></button></div>');
$templateCache.put('src/contacter-contacts/modal-window-lg.html','<div class="modal-dialog " ng-class="{\'modal-lg modal-custom\' : $root.showModalLg, \'modal-lg\': $root.showModalLg === undefined}"><div class="modal-content" uib-modal-transclude></div></div>');}]);